import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";

export const ModalFailure = ({ children }: React.PropsWithChildren<{}>) => {
    return (
        <>
            <p style={{ fontSize: 100 + 'px' }} className="text-center text-danger">
                <FontAwesomeIcon id="FailureStatus" icon={faCircleXmark} aria-hidden="true" />
            </p>
            <div className="text-center">
                {children}
            </div>
        </>
    );
}
